

































import { Component, Mixins } from 'vue-property-decorator';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import Question from '@/components/registration/common/questions/Question.vue';
import EducationListing from '@/components/registration/common/userHistory/EducationListing.vue';
import WorkHistoryListing from '@/components/registration/common/userHistory/WorkHistoryListing.vue';
import Meals from '@/components/registration/common/meals/Meals.vue';
import RegistrationPanelMixing from '@/mixins/registration/RegistrationPanelMixin';
import { namespace } from 'vuex-class';
import lodash from 'lodash';
const registration = namespace('registration');

@Component({
  components: {
    Question,
    EducationListing,
    WorkHistoryListing,
    Meals
  }
})
export default class QuestionsPanel extends Mixins(RegistrationPanelMixing) {
  @registration.State
  public registrationData!: RegistrationData;

  public model = {
    questions: {},
    eventQuestions: {},
    voluenteerQuestions: {},
    education: {},
    workHistory: {},
    eventMeals: {}
  };

  mounted () {
    this.$data.model.questions = this.getPanelData('questions');
    this.$data.model.eventQuestions = this.getPanelData('eventQuestions');
    this.$data.model.voluenteerQuestions = this.getPanelData('volunteerQuestions');
    this.$data.model.education = this.getPanelData('education');
    this.$data.model.workHistory = this.getPanelData('workHistory');
    this.$data.model.eventMeals = this.getPanelData('eventMeals');

    window.scrollTo(0, 0);
  }

  public savePanelData (): Promise<boolean> {
    this.saveRegistrationModel({ data: this.model.questions, model: 'questions' });
    this.saveRegistrationModel({ data: this.model.eventQuestions, model: 'eventQuestions' });
    this.saveRegistrationModel({ data: this.model.voluenteerQuestions, model: 'volunteerQuestions' });
    this.saveRegistrationModel({ data: this.model.education, model: 'education' });
    this.saveRegistrationModel({ data: this.model.workHistory, model: 'workHistory' });
    this.saveRegistrationModel({ data: this.model.eventMeals, model: 'eventMeals' });
    return Promise.resolve(true);
  }

  private ShowCommunityQuestions (): boolean {
    return lodash.find(this.registrationData.formConfig?.fields, (field) => (field.fieldType === 'CommunityQuestions' && field.fieldBehaviour !== 'Hidden')) !== undefined &&
      this.registrationData.questions &&
      this.registrationData.questions.length > 0;
  }
}
